jQuery(document).ready(function ($) {
	$(document.body).on('click', () => $('.site-switch').removeClass('site-switch-expanded'));

	$('.site-switch').on('click', function (event) {
		// Allows anchor link to be clicked without closing dropdown
		event.stopPropagation();
		$(this).toggleClass('site-switch-expanded');
	});
});